var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { MenubarPathStepButton } from './MenubarPathStepButton';
let MenubarPathStep_ = class MenubarPathStep_ extends React.PureComponent {
    get pathLocation() {
        return this.props.step.menubarPath.menubarLocation;
    }
    render() {
        const { step } = this.props;
        let hide = step.depth;
        if (this.pathLocation.type === 'path')
            hide--;
        if (this.pathLocation.locationSteps.depth < hide)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement(MenubarPathStepButton, { step: step })));
    }
};
MenubarPathStep_ = __decorate([
    observer
], MenubarPathStep_);
export { MenubarPathStep_ };
